<template><div><h1>VUX V2.2.1Rc.4 released</h1>
<h2><a href="/en/components/checklist.html">Checklist</a></h2>
<ul><li>[feature] Support prop:label-position</li>
</ul>
<h2><a href="/en/components/popup-radio.html">PopupRadio</a></h2>
<ul><li>[feature] new component</li>
</ul>
<h2><a href="/en/components/previewer.html">Previewer</a></h2>
<ul><li>[enhance] Increase the closing event #1245</li>
</ul>
<h2><a href="/en/components/scroller.html">Scroller</a></h2>
<ul><li>[feature] Support duration and easing for reset function. #1240</li>
</ul>
<h2><a href="/en/components/tab.html">Tab</a></h2>
<ul><li>[enhance] Support param:index on event:on-item-click</li>
</ul>
<h2><a href="/en/components/x-input.html">XInput</a></h2>
<ul><li>[feature] Support labelWidth #1186</li>
</ul>
<h2><a href="/en/components/x-table.html">XTable</a></h2>
<ul><li>[feature] new component</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.2.1Rc.4 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.2.1-rc.4-94.vue?3fd59dd4